import Snapmongo from 'snapmongo';

Snapmongo.config({
  base: '/assets/snapmongo',
  ext: '.json',
});

const main = new Snapmongo('main');
const store = {
  main,
};
export {
  Snapmongo,
  store,
};



// WEBPACK FOOTER //
// ./src/services/index.js